import { createStore } from '@stencil/store';

import { QUESTION_CERTIFIED_CARS, QUESTION_NEW_CARS, QUESTION_USED_CARS } from '../utils/utils.question';

const initialState = {
  makesModels: { values: [] },
  yearRange: { values: [] },
  rvLookingForOptions: [
    {
      value: 'New Cars',
      qRef: QUESTION_NEW_CARS,
      acceptsComment: false,
    },
    {
      value: 'Certified Pre-Owned Cars',
      qRef: QUESTION_CERTIFIED_CARS,
      acceptsComment: false,
    },
    {
      value: 'Used Cars',
      qRef: QUESTION_USED_CARS,
      acceptsComment: false,
    },
  ],
  replacementVehicleOptions: null,
};

const { on, onChange, state, reset } = createStore(initialState);

export { on, onChange, state, reset };
export default state;
